import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("wc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

export const formatINR = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "₹0";
  return "₹" + Number(n).toLocaleString("en-IN", { maximumFractionDigits: 0 });
};

// Compact Indian rupee formatter for visual cards: ₹15Cr, ₹22.5L, ₹50K
export const formatINRShort = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "₹0";
  const v = Number(n);
  const sign = v < 0 ? "-" : "";
  const av = Math.abs(v);
  if (av >= 1_00_00_000) return `${sign}₹${(av / 1_00_00_000).toFixed(2).replace(/\.00$/, "")}Cr`;
  if (av >= 1_00_000) return `${sign}₹${(av / 1_00_000).toFixed(2).replace(/\.00$/, "")}L`;
  if (av >= 1_000) return `${sign}₹${(av / 1_000).toFixed(1).replace(/\.0$/, "")}K`;
  return `${sign}₹${Math.round(av)}`;
};
